<!-- modal.component.html -->
<div class="grid-container modal-content-wrapper">
  <div class="button-wrapper">
    <button type="button" id="close-x-button" class="close fx-close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="grid-row">
    <div class="grid-col-12">
      <div class="padding-left-2 padding-right-2 tablet:padding-left-7 tablet:padding-right-7">
        <div class="modal-header">
          <h3 class="modal-title">{{ title }}</h3>
        </div>
        <div class="modal-body grid-col-12">
          <ng-template #container></ng-template>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="usa-button primary-button font-family-public-sans-normal modal-close-button"
            (click)="close()"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
